import React, { useState, useEffect, useRef, useCallback } from 'react';
import {
	NavLink,
	useLocation
} from "react-router-dom";
import { useSelector, useDispatch, Provider, useStore } from 'react-redux';
import { createUseStyles } from 'react-jss'
import { Button, Input, SpinLoading, Popup, Avatar, List } from 'antd-mobile';
import { useParams } from 'react-router-dom';
import { pushStateHistoryModal, MetaContext, POST, TranslateContext, useAuth, useNavigation, UserConfigContext, UserContext, useTranslateContext, useUserConfigContext, useUserContext, ycStorage, JSX, updateArrayInArray, GETWITH, QueryOrder, LanguageContext } from 'fennec-ui';
import moment from 'moment-timezone';
import 'moment/locale/ru';

// --- mobile --- 
// ---  ---  --- 

// 
import './index.less';

import CRUDE_VseTipiPolzovatelei from '../../../objects/VseTipiPolzovatelei/crude'
import { errorCatch, GET, JSXMap, QueryDetail, READWITH, updateInArray } from 'fennec-ui';
import { Action } from 'fennec-ui'
import REDUX_AkkauntiPolzovatelei from '../../../objects/AkkauntiPolzovatelei/reducer';
import Icofont from 'react-icofont';
import useSound from 'use-sound';
import bubbleSfx from '../../../sfx-shtrih-kod.mp3';
import Collection from '../../components/Collection';
import { Dialog } from '../../../common/Dialog';
import QR from '../../../common/QR';
import uuid from 'react-uuid';
import { eventRoleControler, fire, translate, ycBucket } from '../../../common/Tool';
import { LangSwitchContext, useLangSwitchContext } from '../../../common/Context';
import REDUX_UserConfig from '../../../objects/UserConfig/reducer'
import REDUX_Translate from '../../../objects/Translate/reducer';
import LangSwitchMobile from '../../components/LangSwitchMobile';
import { LogoutOutlined } from '@ant-design/icons';
import YImage from '../../../common/YImage';
import EventListItem from '../../components/EventListItem';
import { Form } from 'antd';
import QRCode from 'react-qr-code';

var _ = require('lodash');

function closest(el, selector) {
	const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
	while (el) {
		if (matchesSelector.call(el, selector)) {
			return el;
		}
		el = el.parentElement;
	}
	return null;
}
const onWrapTouchStart = (e) => {
	// fix touch to scroll background page on iOS
	if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
		return;
	}
	const pNode = closest(e.target, '.am-modal-content');
	if (!pNode) {
		e.preventDefault();
	}
}

const mainDark = "#001529";
const useStyles = createUseStyles({
	fullModal: {
		"& .am-modal-footer": {
			position: "fixed",
			bottom: 0,
			left: 0,
			width: "100%",
			backgroundColor: "white",
			zIndex: 1
		},
		// "& .am-modal-body": {
		//     height: "calc(100vh - 110px)"
		// },
	},
	tabs: {
		'& .am-tabs-default-bar .am-tabs-default-bar-underline': {
			border: "1px #001529 solid"
		}
	},
	fieldName: {
		fontWeight: "300",
		fontSize: "13px"
	},
	fieldValue: {
		fontStyle: "italic",
		color: "black",
		fontWeight: "300",
		fontSize: "13px"
	},
	fieldMicroName: {
		fontWeight: "300",
		fontSize: "13px"
	},
	fieldMicroValue: {
		fontStyle: "italic",
		color: "black",
		fontWeight: "300",
		fontSize: "13px"
	},
	searchInput: {
		'&': {
			height: "100%",
			paddingLeft: "20px",
		},
		'&.am-list-item .am-list-line .am-input-label': {
			width: "25px"
		}
	}
})

function Sidebar(props) {
	// const { open, setOpen } = props;
	const { open, menuClose, getStack } = props;
	let navigate = useNavigation();
	// const history = useHistory();
	// history.push("/home");
	const auth = useAuth();
	const dispatch = useDispatch();
	const t = useTranslateContext();
	const user = useUserContext();
	const langSwitch = useLangSwitchContext();
	const [userConfig, setUserConfig] = useUserConfigContext();
	const location = useLocation();
	const akkauntiPolzovatelei = useSelector(REDUX_AkkauntiPolzovatelei.selector.array);

	// useEffect(() => {
	// 	setOpen(false)
	// }, [location.pathname]);

	const logout = () => {
		auth.logout(() => {
			navigate('/');
		});
	}
	const logoutall = (e) => {
		e.stopPropagation();
		e.preventDefault();

		Dialog.confirm({
			content: t('Вы действительно хотите выйти на всех устройствах?'),
			confirmText: t("Выйти"),
			cancelText: t("Отмена"),
			onConfirm: async () => {
				await auth.logoutall(() => {
					navigate('/');
				});
			},
		})
	}

	const [idCard, setIdCard] = useState()
	const loadIdCard = useCallback(() => {
		GET(auth, '/api/idcard', ({ data }) => {
			if (data) {
				setIdCard(data)
			}
		}, (err) => errorCatch(err))
	}, [auth])

	return (
		<Popup
			visible={open}
			// onMaskClick={() => setOpen(false)}
			onMaskClick={menuClose}
			position='right'
			bodyStyle={{ width: '80vw' }}
		>
			<div className='sidebar'>
				<div>
					{user && <div className='user bg bg-grey dark-5' style={{ padding: "4px" }}>
						<Avatar src={(user.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + user.avatarMin : ""} />
						<div className='user-name'>
							<div style={{ overflow: "hidden", textOverflow: "ellipsis", fontSize: "14px" }}>{user.lastname + " " + user.firstname}</div>
							<div style={{ overflow: "hidden", textOverflow: "ellipsis", fontSize: "12px", color: "#9a9a9ab5" }}>{user.email}</div>
						</div>
						<div>
							<Action
								auth={auth}
								action={() => {
								}}
								object={idCard}
								modal={{
									title: "QR-id"
								}}

								readonly={true}
								mode={"func"}
								noAntForm={true}
								form={(props) => {
									const { object } = props;
									return <div style={{ display: "flex", justifyContent: "center", padding: "5px" }}>
										{object &&
											<div>
												<div className='bg bg-transparent' style={{ display: "flex", justifyContent: "space-evenly" }}>
													<Avatar src={(user?.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + user?.avatarMin : undefined} />

													<div className='user-name'>
														<div style={{ overflow: "hidden", textOverflow: "ellipsis", fontSize: "14px" }}>{user.lastname + " " + user.firstname}</div>
														<div style={{ overflow: "hidden", textOverflow: "ellipsis", fontSize: "12px", color: "#9a9a9ab5" }}>{user.email}</div>
													</div>
												</div>

												<div style={{ padding: "15px 5px 20px 5px", backgroundColor: "white", borderRadius: "6px", textAlign: "center" }}>
													<QRCode level="M" value={object} />
												</div>

												<div style={{ display: "flex", justifyContent: "center" }}>
													<Button onClick={loadIdCard}>Обновить</Button>
												</div>
											</div>}
									</div>
								}}
								trigger={(click) => (
									<div onClick={event => {
										event.stopPropagation();
										loadIdCard()
										click()
									}}>
										<i className="fa fa-qrcode" style={{ color: "black", fontSize: "42px", margin: "3px 5px 0 0" }}></i>
									</div>
								)}
							/>
						</div>
					</div>}
					<div className='logout bg bg-grey' style={{ padding: "4px", marginTop: "5px" }} onClick={logout}>
						<div>
							<LogoutOutlined />
							<span style={{ paddingLeft: "5px" }}> {t("Выход")}</span>
						</div>
						<div style={{ flex: 0, color: "red" }} onClick={logoutall}>
							<Icofont icon="logout" />
						</div>
					</div>
				</div>
				<div>
					{langSwitch}
				</div>
				<div>
					{!!akkauntiPolzovatelei && <div style={{ padding: "5px 10px" }}>
						<div>Баланс:</div>
						{akkauntiPolzovatelei.map((e, idx) => <div key={idx} style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", fontSize: "13px" }}>
							<div>
								№{e.akkaunt.nomerAkkaunta}
							</div>
							<div style={{ flex: "auto", textAlign: "end", paddingLeft: "15px", color: (e.akkaunt.ostatok > 0) ? "green" : "red" }}>
								{Number(e.akkaunt.ostatok.toFixed(2)).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
							</div>
						</div>)}
					</div>}
					<div style={{ padding: "0px 10px" }}>
						<List>
							<List.Item
								prefix={<i className="fa fa-globe" style={{ paddingRight: "4px", color: "blue" }}></i>}
								className={"bg-blue"}>
								<a style={{ fontSize: "14px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/fed/events`}>
									{t("Главный сайт")}
								</a>
							</List.Item>
							<List.Item
								prefix={<Icofont icon="home" style={{ fontSize: "13px", color: "orange" }} />}
								className={"bg-orange"}>
								<a style={{ fontSize: "14px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app`}>
									{t("Личный кабинет")}
								</a>
							</List.Item>
							<List.Item
								prefix={<Icofont icon="ui-calendar" style={{ fontSize: "13px", color: "green" }} />}
								className={"bg-green"}>
								<a style={{ fontSize: "14px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app/switch`}>
									{t("Войти в мероприятие")}
								</a>
							</List.Item>
							<List.Item
								prefix={<Icofont icon="user" style={{ fontSize: "13px" }} />}>
								<a style={{ fontSize: "14px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://auth.${auth.getDomainWithoutSubdomain(window.location.href)}/common/profile`}>
									{t("Профиль")}
								</a>
							</List.Item>
						</List>
					</div>
				</div>
			</div>
		</Popup>
	);
}

const CameraForm = (props) => {
	const { auth, form, event, updateData, allowScan, play } = props;

	// const qr = Form.useWatch('qr', form);
	const [qr, setQr] = useState({ visible: false, data: undefined });

	// useEffect(() => {
	// 	// if (form && qr) {
	// 	// 	form.submit()
	// 	// }
	// 	if (qr) {
	// 		setVisible(true)
	// 	} else {
	// 		setVisible(false)
	// 	}

	// }, [qr])
	return (<div>
		{/* <Form
			form={form}
			onFinish={props.submit}
			labelAlign={"left"}
			layout={"vertical"}
			initialValues={{
			}}
		> */}
		<div>
			<EventListItem
				key={"event"}
				event={event}
				hideRoles={true}
				size="small"
			/>
		</div>
		{/* <Form.Item name={"qr"}> */}
		<QR allowScan={allowScan} visible={!qr?.visible} onChange={(qr) => {
			if (qr) {
				let r = encodeURIComponent(qr);
				setQr({ visible: true, data: r })
				play();
			}
		}} />
		{/* </Form.Item> */}
		<div style={{ fontStyle: "italic", textAlign: "center", color: "#888", fontSize: "15px", height: "100%", lineHeight: "1.5" }}>
			* для проверки билета отсканируйте QR-код
		</div>
		{/* <div style={{ padding: "10px" }}>
			<Button color='primary' style={{ width: "100%" }} onClick={() => {
				let r = encodeURIComponent("sdebswnhweranhewrhweraje54j");
				setQr({ visible: true, data: r })
				play();
			}}>Тест</Button>
		</div> */}
		{/* </Form> */}
		{/* <Action
			auth={auth}
			titles={{
				header: (<div style={{ display: "flex", justifyContent: "center", padding: "10px 15px 0px 15px", fontSize: "16px" }}>
					Билет
				</div>)
			}}

			action={(values, unlock, close) => {
				// handleTicket(item);
				// console.log("Action on dancer", values);
			}}
			form={TicketForm}
			noAntForm={true}
			readonly={true}
			event={event}

			updateData={updateData}
			mode={"func"}

			fire={true}
			visible={!!qr}
			code={qr}
		/> */}

		<Dialog
			auth={auth}
			visible={qr?.visible}
			content={() => (<TicketForm auth={auth} code={qr?.data} event={event} updateData={updateData} />)}
			titles={{
				header: (<div style={{ display: "flex", justifyContent: "center", padding: "10px 15px 0px 15px", fontSize: "16px" }}>
					Билет
				</div>)
			}}
			stack={
				[() => { setQr({ visible: false, data: undefined }) }]
			}

			footer={({
				close }) => [{
					name: (<span><Icofont icon="qr-code" /> Сканировать следующий QR-код</span>),
					callback: () => {
						if (close) {
							close();
						}
					},
					options: {
						type: "primary"
					}
				}]}
		/>
	</div>)
};

function CameraSettingsForm(props) {
	const classes = useStyles()
	const { auth, event } = props;
	const user = useUserContext();
	const [yacheiki, setYacheiki] = React.useState();
	const [active, setActive] = useState(false);
	const [loading, setLoading] = useState(false);
	useEffect(() => {
		setLoading(true);
		GETWITH(auth, `/api/yacheikiuslugi/list/controller/meropriyatie/${event.ID}`, [
			QueryOrder("nazvanie", "ASC")
		], ({ data }) => {
			// setYacheiki(data);
			GETWITH(auth, `/api/proveryaemie-yacheiki/${event.ID}`, [
				QueryOrder("yacheika.nazvanie", "ASC")
			], ({ data: datax }) => {
				setYacheiki(data?.map(e => ({ ...e, proveryaemie: datax?.find(x => e.ID === x?.yacheikaID) })));
				setLoading(false);
			}, (err) => errorCatch(err, () => setLoading(false)));
		}, (err) => errorCatch(err, () => setLoading(false)));

	}, [event])
	const getKontrolerID = useCallback(() => _.first(event?.controllersMeropriyatie)?.ID, [event])
	const activeOnly = () => setActive(!active);
	// 
	const clear = useCallback(() => {
		setLoading(true);
		GET(auth, `/api/proveryaemie-yacheiki/clear/${getKontrolerID()}`,
			({ data }) => {
				setYacheiki(o => o?.map(e => ({ ...e, proveryaemie: undefined })));
				setLoading(false);
			}, (err) => errorCatch(err, () => setLoading(false)));
	}, [event]);
	return (<div style={{ height: '100%', display: "flex", flexDirection: "column" }}>
		<div style={{ overflowY: 'scroll', flex: "1" }}>
			<div style={{ padding: "0px 5px" }}>
				<div style={{ display: "flex", justifyContent: "flex-start", flexDirection: "column" }}>
					<div>
						<EventListItem
							key={"event"}
							event={event}
							hideRoles={true}
							size="small"
						/>
					</div>
					<div style={{ padding: "0 5px" }}>
						{!!loading && <div style={{
							width: "100%",
							minHeight: "150px",
							display: "flex",
							justifyContent: "center",
							alignItems: "center"
						}}>
							<SpinLoading style={{ '--size': '32px' }} />
						</div>}
						<div>
							{yacheiki && <div className='bg bg-grey' style={{ marginBottom: "5px", display: "flex", justifyContent: "space-between" }}>
								<div style={{ color: "red", padding: "0 5px" }} onClick={clear}>
									<Icofont icon="close" />
									<span className={classes.fieldValue} style={{ color: "red" }} >
										Очистить
									</span>
								</div>
								<div style={{ color: "#1890ff", padding: "0 5px" }} onClick={activeOnly}>
									<span className={classes.fieldValue} style={{ color: "#1890ff" }} >
										{(active) ? "Активные" : "Все услуги"}
									</span>
									<Icofont icon="hand-up" />
								</div>
							</div>}
							{yacheiki && <Collection
								data={(active) ? yacheiki?.filter(e => !!e.proveryaemie) : yacheiki}
								noheader={true}
								getSelectedOnly={true}
								selection="checkbox"
								auth={auth}
								noPrint={true}
								noPagination={true}
								size="small"
								mode="list"
								listRenderItem={(item, index) => {
									return (<div key={uuid()} style={{ padding: "4px 0", borderBottom: "1px solid rgb(225, 225, 225, 0.5)" }}>
										<Action
											auth={auth}
											action={(values, unlock, close) => {
												let url = (!item.proveryaemie) ? `/api/proveryaemie-yacheiki/new` : `/api/proveryaemie-yacheiki/delete`;
												POST(auth, url, (item.proveryaemie) ? item.proveryaemie : { yacheikaID: item.ID, kontrolerID: getKontrolerID() }, ({ data }) => {
													if (!item.proveryaemie) {
														setYacheiki(o => updateInArray(o, { ...item, proveryaemie: data }))
													} else {
														setYacheiki(o => updateInArray(o, { ...item, proveryaemie: undefined }))
													}
												}, errorCatch);
											}}
											object={item}
											mode={"func"}
											noAntForm={true}
											trigger={(click) => (
												<div onClick={click}>
													<div
														className={(!!item.proveryaemie) ? 'bg bg-green light-2' : ""}
														style={{
															textAlign: "left",
															display: "flex",
															justifyContent: "space-between",
															flexDirection: "row",
															flexWrap: "nowrap",
															alignItems: "stretch",
															width: "100%",
															minHeight: "40px",
															alignItems: "center",
															background: (!!item.proveryaemie) ? "repeating-linear-gradient(115deg, transparent, transparent 3px, rgb(140 245 154 / 50%) 3px, rgb(140 245 154 / 50%) 6px)" : "",
															textDecorationColor: (!!item.proveryaemie) ? "rgb(0,0,0,0.5)" : ""
														}}>
														<div style={{ flex: "25px" }}>
															<div style={{ padding: "0px 4px 0px 4px", fontSize: "16px" }}>
																{(!!item.proveryaemie) && <Icofont icon='tick-boxed' />}
															</div>
														</div>
														<div style={{ flex: "auto", width: "100%" }}>
															<div style={{ color: (!!item.proveryaemie) ? "#afafaf" : "#000", whiteSpace: "initial", fontSize: "14px" }}>
																<div style={{ fontWeight: "500" }}>{item.nazvanie}</div>
																<div style={{ fontWeight: "300" }}>
																	{<div>
																		{(item.opisanie && item.nazvanie !== item.opisanie) && <div style={{ fontSize: "13px" }}>{item.opisanie}</div>}
																	</div>}
																</div>
															</div>
														</div>
													</div>
												</div>
											)}
										/>
									</div>)
								}
								}
								collectionActions={() => []}
								modelActions={() => []}
							/>}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>)
}
const TicketAction = (props) => {
	const { auth, item, setTicket, updateData, color, userID } = props;

	const isUsed = useCallback((item) => {
		if (userID == item.partnerID) {
			return item.usedPartner
		}
		if (userID == item.polzovatelID) {
			return item.used
		}
	}, [userID])

	const setCheckTicket = useCallback((item) => {
		let url = (!isUsed(item)) ? `/api/usluga-ticket/set-used/${item.ID}/${userID || 0}` : `/api/usluga-ticket/unset-used/${item.ID}/${userID || 0}`;
		GET(auth, url, ({ data }) => {
			setTicket(o => {
				return updateInArray(o, data)
			});
			if (updateData) {
				updateData([data]);
			}
		}, errorCatch);
	}, [updateData, userID]);

	return (<Action
		auth={auth}
		action={(values, unlock, close) => setCheckTicket(item)}
		object={item}
		mode={"func"}
		noAntForm={true}
		trigger={(click) => (
			<div onClick={click}>
				<div
					className={(color) ? `bg bg-${color} border-${color} dark-3` : ""}
					style={{
						borderWidth: "2px",
						textAlign: "left",
						display: "flex",
						justifyContent: "space-between",
						flexDirection: "row",
						flexWrap: "nowrap",
						alignItems: "stretch",
						width: "100%",
						minHeight: "40px",
						alignItems: "center",
						// userID == partnerID usedPartner
						// userID == polzovatelID used
						background: (isUsed(item) === true) ? "repeating-linear-gradient(115deg, transparent, transparent 3px, rgb(225, 225, 225, 0.5) 3px, rgb(225, 225, 225,0.5) 6px)" : "",
						textDecorationColor: (isUsed(item) === true) ? "rgb(0,0,0,0.5)" : ""
					}}>
					<div style={{ flex: "25px" }}>
						<div style={{ padding: "0px 4px 0px 4px", fontSize: "16px" }}>
							{isUsed(item) && <Icofont icon='tick-boxed' />}
						</div>
					</div>
					<div style={{ flex: "auto", width: "100%" }}>
						<div style={{ color: (isUsed(item)) ? "#afafaf" : "#000", whiteSpace: "initial", fontSize: "14px" }}>
							<div style={{ fontWeight: "500" }}>{item.uslugaKlientu.yacheikaUsluga.nazvanie}</div>
							<div style={{ fontWeight: "300" }}>
								{<div>
									{(item.uslugaKlientu.yacheikaUsluga.opisanie && item.uslugaKlientu.yacheikaUsluga.nazvanie !== item.uslugaKlientu.yacheikaUsluga.opisanie) && <div style={{ fontSize: "13px" }}>{item.uslugaKlientu.yacheikaUsluga.opisanie}</div>}
								</div>}
							</div>
						</div>
						{(item.kategoriya && item.kategoriya.kategoriya) && <div style={{ color: (isUsed(item)) ? "#afafaf" : "#1890ff", paddingLeft: "5px", fontSize: "13px" }}>
							<span>
								<span> - </span>
								<span style={{ fontStyle: "italic" }}>
									{item.kategoriya.kategoriya.tantsevalnayaDistsiplina.nazvanie + " / " + item.kategoriya.kategoriya.kategoriyaUchastnikov.nazvanie}
								</span>
							</span>
						</div>}
					</div>
					<div style={{ flex: "110px" }}>
						<div style={{ alignSelf: "flex-start", color: (isUsed(item)) ? "#afafaf" : "rgb(63, 134, 0)", textAlign: "end", padding: "0px 0px 0px 15px", fontWeight: "400", fontSize: "11px" }}>
							Оплачено:
						</div>
						<div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 15px", fontWeight: "500", fontSize: "14px" }}>
							<div style={{ color: (isUsed(item)) ? "#afafaf" : "rgb(63, 134, 0)" }}>
								{(item.summa !== item.summaDoPromokoda) ? Number(item.summa.toFixed(2)).toLocaleString('ru', { style: 'currency', currency: 'RUB' }) : Number(item.summaDoPromokoda.toFixed(2)).toLocaleString('ru', { style: 'currency', currency: 'RUB' })}
							</div>
						</div>
					</div>
				</div>
			</div>
		)} />)
};
const EventUserTicketAction = (props) => {
	const { auth, item, setEventUsers, updateData, color } = props;

	const setCheckTicket = useCallback((item) => {
		let url = (!item?.used) ? `/api/event-user-ticket/set-used/${item.ID}` : `/api/event-user-ticket/unset-used/${item.ID}`;
		GET(auth, url, ({ data }) => {
			setEventUsers(o => {
				return updateInArray(o, data)
			});
			if (updateData) {
				updateData(undefined, [data]);
			}
		}, errorCatch);
	}, [updateData]);

	return (<Action
		auth={auth}
		action={(values, unlock, close) => setCheckTicket(item)}
		object={item}
		mode={"func"}
		noAntForm={true}
		trigger={(click) => (
			<div onClick={click}>
				<div
					className={(color) ? `bg bg-${color} border-${color} dark-3` : ""}
					style={{
						borderWidth: "2px",
						textAlign: "left",
						display: "flex",
						justifyContent: "space-between",
						flexDirection: "row",
						flexWrap: "nowrap",
						alignItems: "stretch",
						width: "100%",
						minHeight: "40px",
						alignItems: "center",
						// userID == partnerID usedPartner
						// userID == polzovatelID used
						background: (item?.used) ? "repeating-linear-gradient(115deg, transparent, transparent 3px, rgb(225, 225, 225, 0.5) 3px, rgb(225, 225, 225,0.5) 6px)" : "",
						textDecorationColor: (item?.used) ? "rgb(0,0,0,0.5)" : ""
					}}>
					<div style={{ flex: "25px" }}>
						<div style={{ padding: "0px 4px 0px 4px", fontSize: "16px" }}>
							{item?.used && <Icofont icon='tick-boxed' />}
						</div>
					</div>
					<div style={{ flex: "auto", width: "100%" }}>
						<div style={{ color: (item?.used) ? "#afafaf" : "#000", whiteSpace: "initial", fontSize: "14px" }}>
							<div style={{ fontWeight: "500" }}>{item?.eventUserType?.description}</div>
							{/* <div style={{ fontWeight: "300" }}>
								{<div>
									{(item.uslugaKlientu.yacheikaUsluga.opisanie && item.uslugaKlientu.yacheikaUsluga.nazvanie !== item.uslugaKlientu.yacheikaUsluga.opisanie) && <div style={{ fontSize: "13px" }}>{item.uslugaKlientu.yacheikaUsluga.opisanie}</div>}
								</div>}
							</div> */}
						</div>
					</div>
				</div>
			</div>
		)} />)
};
function TicketForm(props) {
	const classes = useStyles()
	const { auth, event, code, object, updateData } = props;
	const [ticket, setTicket] = React.useState(null);
	const [eventUsers, setEventUsers] = React.useState();
	const [other, setOther] = React.useState(null);
	const [proverka, setProverka] = React.useState();
	const [active, setActive] = useState(false);
	const [loading, setLoading] = useState(false);
	useEffect(() => {
		if (object?.TicketList) {
			setTicket(object.TicketList)
		}
		if (object?.EventUsers) {
			setEventUsers(object.EventUsers?.filter(a => (a?.eventUserTypeID != 3 && a?.eventUserTypeID != 8)))
		}
	}, [object])
	useEffect(() => {
		if (ticket && proverka) {
			setOther(_.differenceBy(ticket, _.concat(proverka?.existProvYacheikiUsed, proverka?.existProvYacheikiNotUsed), "ID"))
		}
	}, [ticket, proverka])
	useEffect(() => {
		if (code) {
			setLoading(true);
			GET(auth, `/api/check-ticket/${event.ID}?ticket=${code}`,
				({ data, userID, existProvYacheikiNotUsed, existProvYacheikiUsed, notExistProvYacheiki, proveryaemieYacheiki, eventUsers }) => {
					setProverka({
						userID, existProvYacheikiNotUsed, existProvYacheikiUsed, notExistProvYacheiki, proveryaemieYacheiki
					})
					setOther(_.differenceBy(data, _.concat(existProvYacheikiUsed, existProvYacheikiNotUsed), "ID"))
					let v = data.sort((a, b) => {
						if (a.uslugaKlientu.yacheikaUsluga.nazvanie > b.uslugaKlientu.yacheikaUsluga.nazvanie) {
							return 1;
						}
						if (a.uslugaKlientu.yacheikaUsluga.nazvanie < b.uslugaKlientu.yacheikaUsluga.nazvanie) {
							return -1;
						}
						return 0;
					})
					setLoading(false);
					setTicket(v);
					if (eventUsers?.length) {
						setEventUsers(eventUsers?.filter(a => (a?.eventUserTypeID != 3 && a?.eventUserTypeID != 8)))
					}
					if (proveryaemieYacheiki?.length > 0 && updateData) {
						updateData(data);
					}

				}, (err) => errorCatch(err, () => setLoading(false)));
		}
	}, [code, event])
	useEffect(() => {
		if (!object?.TicketList && !code) {
			setTicket(null)
			setProverka(undefined)
		}
	}, [code, object])
	const activeOnly = () => setActive(!active);

	const isUsed = useCallback((item) => {
		var userID = proverka?.userID || object?.Polzovatel?.ID;
		if (userID == item.partnerID) {
			return item.usedPartner
		}
		if (userID == item.polzovatelID) {
			return item.used
		}
	}, [proverka, object?.Polzovatel?.ID])

	return (<div style={{ height: '100%', display: "flex", flexDirection: "column" }}>
		<div style={{ overflowY: 'scroll', flex: "1" }}>
			<div style={{ padding: "0px 5px" }}>
				<div style={{ display: "flex", justifyContent: "flex-start", flexDirection: "column" }}>
					<div>
						<EventListItem
							key={"event"}
							event={event}
							hideRoles={true}
							size="small"
						/>
					</div>
					<div style={{ padding: "0 5px" }}>
						{!!loading && <div style={{
							width: "100%",
							minHeight: "150px",
							display: "flex",
							justifyContent: "center",
							alignItems: "center"
						}}>
							<SpinLoading style={{ '--size': '32px' }} />
						</div>}
						<div>

							{/* 
							proverka.existProvYacheikiNotUsed
							proverka.existProvYacheikiUsed
							proverka.notExistProvYacheiki
							proverka.proveryaemieYacheiki 
							*/}
							{(!!ticket?.length) && JSXMap([_.head(ticket)], (item, idx) => {
								let userName = ""
								if (item) {
									userName = item.polzovatelStrokoi || ""
									if (item.polzovatel && item.polzovatel.ID == (proverka?.userID || object?.Polzovatel?.ID)) {
										userName = item.polzovatel.lastname + " " + item.polzovatel.firstname
									} else if (item.tipTDID == 2 && item.partner && item.partner.ID == (proverka?.userID || object?.Polzovatel?.ID)) {
										userName = item.partner.lastname + " " + item.partner.firstname
									}
								}
								return (<div key={idx}>
									{item && <div>
										<span className={classes.fieldMicroName}>Пользователь: </span>
										<span className={classes.fieldMicroValue}>
											{(!!userName) ? userName : ""}
										</span>
									</div>}
								</div>)
							})}
							{(!ticket?.length && !!eventUsers?.length) && JSXMap([_.head(eventUsers)], (item, idx) => {
								let userName = item?.user?.lastname + " " + item?.user?.firstname
								return (<div key={idx}>
									{item && <div>
										<span className={classes.fieldMicroName}>Пользователь: </span>
										<span className={classes.fieldMicroValue}>
											{(!!userName) ? userName : ""}
										</span>
									</div>}
								</div>)
							})}
							{(ticket && !proverka?.proveryaemieYacheiki?.length) && <div className='bg bg-grey' style={{ marginBottom: "5px", display: "flex", justifyContent: "right" }}>
								<div style={{ color: "#1890ff", padding: "0 5px" }} onClick={activeOnly}>
									<a className={classes.fieldValue} style={{ color: "#1890ff" }} href="#">
										{(active) ? "Активные" : "Все услуги"}
									</a>
									<Icofont icon="hand-up" />
								</div>
							</div>}

							{(proverka?.proveryaemieYacheiki?.length > 0) && <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
								{(proverka?.notExistProvYacheiki?.length > 0) && <div style={{ paddingBottom: "5px" }}>
									<div style={{ color: "rgba(0,0,0,.85)", fontSize: "13px", fontWeight: "lighter" }}>Нет проверяемых услуг</div>
									{JSXMap(proverka?.notExistProvYacheiki, (item, idx) => {
										return (<div key={item.yacheikaID}>
											<div
												className='bg bg-red border-red dark-3'
												style={{
													borderWidth: "2px",
													textAlign: "left",
													display: "flex",
													justifyContent: "space-between",
													flexDirection: "row",
													flexWrap: "nowrap",
													alignItems: "stretch",
													width: "100%",
													minHeight: "40px",
													alignItems: "center",
													// textDecoration: "line-through",
													//background: "repeating-linear-gradient(115deg, transparent, transparent 3px, rgb(225, 0, 0, 0.5) 3px, rgb(225, 0, 0,0.5) 6px)",
													//textDecorationColor: "rgb(0,0,0,0.5)"
												}}>
												<div style={{ flex: "25px" }}>
													<div style={{ padding: "0px 4px 0px 4px", fontSize: "16px" }}>
														<Icofont icon='close' style={{ color: "red", fontSize: "12px" }} />
													</div>
												</div>
												<div style={{ flex: "auto", width: "100%" }}>
													<div style={{ color: "red", whiteSpace: "initial", fontSize: "14px" }}>
														<div style={{ fontWeight: "500" }}>{item.yacheika.nazvanie}</div>
														<div style={{ fontWeight: "300" }}>
															{<div>
																{(item.yacheika.opisanie && item.yacheika.nazvanie !== item.yacheika.opisanie) && <div style={{ fontSize: "13px" }}>{item.yacheika.opisanie}</div>}
															</div>}
														</div>
													</div>
												</div>
											</div>
										</div>)
									})}
								</div>}
							</div>}

							{(ticket && !proverka?.proveryaemieYacheiki?.length) && <Collection
								data={(active) ? ticket?.filter(e => isUsed(e) === false) : ticket}
								noheader={true}
								getSelectedOnly={true}
								selection="checkbox"
								auth={auth}
								noPrint={true}
								noPagination={true}
								size="small"
								mode="list"
								hideNotData={true}
								listRenderItem={(item, index) => (<div key={uuid()} style={{ padding: "4px 0", borderBottom: "1px solid rgb(225, 225, 225, 0.5)" }}>
									<TicketAction auth={auth} item={item} updateData={updateData} setTicket={setTicket} userID={proverka?.userID || object?.Polzovatel?.ID} />
								</div>)}
								collectionActions={() => []}
								modelActions={() => []}
							/>}

							{(ticket && proverka?.proveryaemieYacheiki?.length > 0) && <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>

								{(proverka?.existProvYacheikiUsed?.length > 0) && <div>
									<div style={{ color: "rgba(0,0,0,.85)", fontSize: "13px", fontWeight: "lighter" }}>Услуги уже были отмечены ранее</div>
									<Collection
										data={(active) ? ticket?.filter(e => isUsed(e) === false && !!proverka?.existProvYacheikiUsed?.find(a => a.ID === e.ID)) : ticket?.filter(e => !!proverka?.existProvYacheikiUsed?.find(a => a.ID === e.ID))}
										noheader={true}
										getSelectedOnly={true}
										selection="checkbox"
										auth={auth}
										noPrint={true}
										noPagination={true}
										size="small"
										mode="list"
										listRenderItem={(item, index) => (<div key={uuid()} style={{ padding: "4px 0", borderBottom: "1px solid rgb(225, 225, 225, 0.5)" }}>
											<TicketAction auth={auth} item={item} updateData={updateData} setTicket={setTicket} color={"orange"} userID={proverka?.userID || object?.Polzovatel?.ID} />
										</div>)}
										collectionActions={() => []}
										modelActions={() => []}
									/>
								</div>}
								{(proverka?.existProvYacheikiNotUsed?.length > 0 && (proverka?.notExistProvYacheiki?.length > 0 || proverka?.existProvYacheikiUsed?.length > 0)) && <div>
									<div style={{ color: "rgba(0,0,0,.85)", fontSize: "13px", fontWeight: "lighter" }}>Должны быть отмечены (не отмечены автоматически)</div>
									<Collection
										data={(active) ? ticket?.filter(e => isUsed(e) === false && !!proverka?.existProvYacheikiNotUsed?.find(a => a.ID === e.ID)) : ticket?.filter(e => !!proverka?.existProvYacheikiNotUsed?.find(a => a.ID === e.ID))}
										noheader={true}
										getSelectedOnly={true}
										selection="checkbox"
										auth={auth}
										noPrint={true}
										noPagination={true}
										size="small"
										mode="list"
										listRenderItem={(item, index) => (<div key={uuid()} style={{ padding: "4px 0", borderBottom: "1px solid rgb(225, 225, 225, 0.5)" }}>
											<TicketAction auth={auth} item={item} updateData={updateData} setTicket={setTicket} color={"blue"} userID={proverka?.userID || object?.Polzovatel?.ID} />
										</div>)}
										collectionActions={() => []}
										modelActions={() => []}
									/>
								</div>}
								{((proverka?.existProvYacheikiNotUsed?.length > 0) && (!proverka?.existProvYacheikiUsed?.length && !proverka?.notExistProvYacheiki?.length)) && <div>
									<div style={{ color: "rgba(0,0,0,.85)", fontSize: "13px", fontWeight: "lighter" }}>Отмечено автоматически</div>
									<Collection
										data={(active) ? ticket?.filter(e => isUsed(e) === false && !!proverka?.existProvYacheikiNotUsed?.find(a => a.ID === e.ID)) : ticket?.filter(e => !!proverka?.existProvYacheikiNotUsed?.find(a => a.ID === e.ID))}
										noheader={true}
										getSelectedOnly={true}
										selection="checkbox"
										auth={auth}
										noPrint={true}
										noPagination={true}
										size="small"
										mode="list"
										listRenderItem={(item, index) => (<div key={uuid()} style={{ padding: "4px 0", borderBottom: "1px solid rgb(225, 225, 225, 0.5)" }}>
											<TicketAction auth={auth} item={item} updateData={updateData} setTicket={setTicket} color={"green"} userID={proverka?.userID || object?.Polzovatel?.ID} />
										</div>)}
										collectionActions={() => []}
										modelActions={() => []}
									/>
								</div>}
								<div>
									<div style={{ color: "rgba(0,0,0,.85)", fontSize: "13px", fontWeight: "lighter" }}>Другие услуги</div>
									<Collection
										data={(active) ? other?.filter(e => isUsed(e) === false) : other}
										noheader={true}
										getSelectedOnly={true}
										selection="checkbox"
										auth={auth}
										noPrint={true}
										noPagination={true}
										size="small"
										mode="list"
										listRenderItem={(item, index) => (<div key={uuid()} style={{ padding: "4px 0", borderBottom: "1px solid rgb(225, 225, 225, 0.5)" }}>
											<TicketAction auth={auth} item={item} updateData={updateData} setTicket={setTicket} userID={proverka?.userID || object?.Polzovatel?.ID} />
										</div>)}
										collectionActions={() => []}
										modelActions={() => []}
									/>
								</div>
							</div>}
							{((active) ? !!eventUsers?.filter(e => (!e?.used))?.length : !!eventUsers?.length) && <div style={{ display: "flex", flexDirection: "column", gap: "5px", marginTop: "10px" }}>
								<div>
									<div style={{ color: "rgba(0,0,0,.85)", fontSize: "13px", fontWeight: "lighter" }}>Персонал</div>
									<Collection
										data={(active) ? eventUsers?.filter(e => (!e?.used)) : eventUsers}
										noheader={true}
										getSelectedOnly={true}
										selection="checkbox"
										auth={auth}
										noPrint={true}
										noPagination={true}
										size="small"
										mode="list"
										listRenderItem={(item, index) => (<div key={uuid()} style={{ padding: "4px 0", borderBottom: "1px solid rgb(225, 225, 225, 0.5)" }}>
											<EventUserTicketAction auth={auth} item={item} updateData={updateData} setEventUsers={setEventUsers} />
										</div>)}
										collectionActions={() => []}
										modelActions={() => []}
									/>
								</div>
							</div>}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>)
}

function Checkticket(props) {
	let navigate = useNavigation();
	let { id } = useParams();
	const auth = useAuth();
	const { history } = props;
	const classes = useStyles()
	const dispatch = useDispatch();
	// const store = useStore();
	const [play] = useSound(bubbleSfx);

	const userConfig = useSelector(REDUX_UserConfig.selector.object) || {};
	const [language, setLanguage] = useState({ lang: (auth.getCookie("lang") || "ru") })
	const translates = useSelector(REDUX_Translate.selector.object);
	const t = React.useMemo(() => _.bind(translate, {
		translate: translates,
		config: language
	}), [translates, language]);
	// const t = useTranslateContext();
	// console.log(t("да"));
	const setUserConfig = (name, value, onChange) => {
		POST(auth, "/api/setuserconfig", {
			key: name,
			value: value
		}, ({ data }) => {
			var arr = [data];
			var obj = Object.fromEntries(arr.map(i => {
				return [
					i.key,
					i.value
				]
			}));
			let i = { ...userConfig, ...obj };
			let o = REDUX_UserConfig.actions.setObject(i);
			dispatch(o);
			if (onChange) {
				onChange(i);
			}
		}, errorCatch);
	};

	const meta = useSelector(state => state.meta);
	const user = useSelector(state => state.home.user);

	const headerRef = useRef(null);

	const [online, setOnline] = useState(false);
	const [loading, setLoading] = useState(false);
	const [filter, setFilter] = useState("");
	// const [camera, setCamera] = useState(false);
	const [active, setActive] = useState(true);


	// const [cart, setCart] = useState(undefined);
	const [event, setEvent] = useState(undefined);
	const [tickets, setTickets] = useState();

	const updateData = (ticketList, eventUsers) => {
		setTickets(o => {
			let z = [...o]
			for (let i = 0; i < z.length; i++) {
				const item = z[i];
				if (ticketList?.length && _.some(item?.TicketList, (v) => ticketList.find(x => x.ID === v.ID))) {
					z[i] = { ...item, TicketList: updateArrayInArray(item.TicketList, ticketList) }
				}
				if (eventUsers?.length && _.some(item?.EventUsers, (v) => eventUsers.find(x => x.ID === v.ID))) {
					z[i] = { ...item, EventUsers: updateArrayInArray(item.EventUsers, eventUsers) }
				}
			}
			return z
		})
	}

	useEffect(
		() => {
			auth.fetch('/api/meta').then(res => {
				if (res && res.data && dispatch) {
					dispatch({ type: 'META', payload: res.data })
				}
			});
			auth.fetch('/api/iam').then(res => {
				if (res && res.data) {
					dispatch({ type: 'USER', payload: res.data })
				}
			});
			READWITH(auth, 'Translate', [
				QueryDetail("model")
			], ({ data }) => {
				if (data.length > 0) {
					let o = Object.fromEntries(data.map(i => {
						return [
							i.key,
							{
								ru: i.ru,
								en: i.en,
								es: i.es,
								tr: i.tr,
							},
						]
					}));
					dispatch(REDUX_Translate.actions.setObject(o));
				}
			}, errorCatch)
			READWITH(auth, 'UserConfig', [
				QueryDetail("model")
			], ({ data }) => {
				if (data.length > 0) {
					var obj = Object.fromEntries(data.map(i => {
						return [
							i.key,
							i.value
						]
					}));
					dispatch(REDUX_UserConfig.actions.setObject(obj));
				}
			}, errorCatch)
			CRUDE_VseTipiPolzovatelei.read(auth, (data) => {
				if (data.length > 0) {
					dispatch({ type: 'ROLE', payload: data });
				}
			}, 'model', 's-id=ASC');

			// /api/yacheikiuslugi/list/controller/meropriyatie/{meropriyatieID}
			// /api/proveryaemie-yacheiki/{meropriyatieID}
			// /api/proveryaemie-yacheiki/new
			// /api/proveryaemie-yacheiki/delete

			GET(auth, `/api/meropriyatiya/list/com?detail=model&w-id=${id}`,
				({ data }) => {
					if (data && data.length) {
						setEvent(data[0]);
					}
				}, errorCatch);
			GET(auth, `/api/ticket/all/bymeropriyatie/${id}`, ({ data }) => {
				setTickets(data.map((e, idx) => ({ ID: idx + 1, ...e })));
			}, errorCatch);
			RefreshAkkaunti();
			auth.openSocket("/ws/service", "service",
				function (type, payload) {
					if (type === "reload") {
						window.location.href = window.location.href;
					}
					switch (type) {
						case "siteaccess":
							dispatch({ type: "SITE_ACCESS", payload: payload });
							break;
						case "AkkauntiPolzovatelei":
							dispatch(REDUX_AkkauntiPolzovatelei.actions.updateArray([payload]));
							break;
						case "NeedUpdateAkkauntPolzovatelya":
							RefreshAkkaunti();
							break;
						default:
							break;
					}
				},
				//onopen
				function () {
					setOnline(true);
				},
				//onclose
				function () {
					setOnline(false);
				}
			);
			return () => {
				auth.closeSocket("service");
			};
		}, []);
	const _RefreshAkkaunti = () => {
		READWITH(auth, "AkkauntiPolzovatelei", [
			QueryDetail("model")
		], ({ data }) => {
			if (data) {
				dispatch(REDUX_AkkauntiPolzovatelei.actions.updateArray(data));
			}
		}, errorCatch);
	};
	var RefreshAkkaunti = _.throttle(_RefreshAkkaunti, 3000, { 'trailing': false });
	const logout = () => {
		auth.logout(() => {
			navigate('/app');
			// history.go(0);
		});
	}

	// const [open, setOpen] = useState(false);
	// const onOpenChange = () => {
	// 	setOpen(!open);
	// } 

	const stack = [];
	const getStack = React.useCallback(() => {
		return stack;
	}, []);

	const [open, setOpen] = useState(false);
	const menuClose = () => {
		if (open) {
			window.history.back();
		}
	}
	const onOpenChange = () => {
		if (!open) {
			pushStateHistoryModal(setOpen, getStack);
			setOpen(true);
			return
		}
		menuClose();
	}

	const go = (to) => {
		navigate(to);
		// history.go(0);
	}
	const cumulativeOffset = function (element) {
		var top = 0, left = 0;
		if (!element) return {
			top: top,
			left: left
		};
		do {
			top += element.offsetTop || 0;
			left += element.offsetLeft || 0;
			element = element.offsetParent;
		} while (element);

		return {
			top: top,
			left: left
		};
	};

	const isUsed = useCallback((item, object) => {
		if (object?.Polzovatel?.ID == item.partnerID) {
			return item.usedPartner
		}
		if (object?.Polzovatel?.ID == item.polzovatelID) {
			return item.used
		}
	}, [])

	const filteredTickets = React.useCallback(() => {
		if (tickets && tickets.length) {
			let v = tickets.map(e => {

				let usedTicketList = e.TicketList.every(a => {
					return (isUsed(a, e) === true)
				})

				let usedEventUsers = e.EventUsers.every(a => {
					//Исключеме участников и зрителей, потому что они проверяются в списке TicketList
					if (a?.eventUserTypeID == 3 || a?.eventUserTypeID == 8 || a?.used) {
						return true
					}
					return false
				})

				return {
					...e,
					used: usedTicketList && usedEventUsers
				}
			})?.filter(e => e.Name.toLowerCase().includes(filter.toLowerCase()))
			return v;
		} else {
			return []
		}
	}, [tickets, filter, active])

	const [eventCollapse, setEventCollapse] = useState(true);
	const [allowScan, setAllowScan] = useState(false);

	return (
		<TranslateContext.Provider value={t}>
			<MetaContext.Provider value={meta}>
				<UserContext.Provider value={user}>
					<UserConfigContext.Provider value={[userConfig, setUserConfig]}>
						<LanguageContext.Provider value={[language, setLanguage]}>
							<LangSwitchContext.Provider value={<LangSwitchMobile userConfig={userConfig} />}>
								<div className='app'>
									<div className='header' style={{ display: "flex", justifyContent: "space-between", backgroundColor: mainDark }}>
										<NavLink to="/app">
											<div style={{ flex: 0 }}>
												<div className="logo-mobile" />
											</div>
										</NavLink>
										<div style={{ flex: 0 }}>
											<div className='sider-button'>
												<Icofont key="1" icon="navigation-menu" onClick={onOpenChange} />
											</div>
										</div>
									</div>
									<div className='content'>
										<Sidebar open={open} menuClose={menuClose} getStack={getStack} />
										<div className='page' style={{ height: "100%" }}>
											<div style={{ height: "100%" }}>
												{event && <div style={{ height: "100%" }}>
													<div style={{ display: "flex", justifyContent: "flex-start", flexDirection: "column", height: "100%" }}>
														{!!loading && <div style={{
															width: "100%",
															minHeight: "150px",
															display: "flex",
															justifyContent: "center",
															alignItems: "center"
														}}>
															<SpinLoading style={{ '--size': '32px' }} />
														</div>}
														<div>
															<div></div>
															{eventCollapse && <EventListItem
																key={"event"}
																event={event}
																hideRoles={true}
																size="small"
															/>}
														</div>
														<div style={{ padding: "5px" }}>
															<div style={{ display: "flex", gap: "5px" }}>
																<div style={{ flex: "1 1 auto", display: "flex", flexDirection: "column", gap: "5px" }}>
																	<Button size='small' style={{ width: "100%" }} onClick={() => go('/app/common/events')}>Мои мероприятия</Button>
																	<Dialog
																		auth={auth}
																		stack={[]}
																		content={() => (<CameraSettingsForm auth={auth} event={event} />)}
																		titles={{
																			header: (<div style={{ display: "flex", justifyContent: "center", padding: "10px 15px 0px 15px", fontSize: "16px" }}>
																				Автоматически отмечать услуги
																			</div>)
																		}}
																		trigger={(click) => (
																			<Button size='small' style={{ width: "100%" }} onClick={click}><i className="fa fa-cogs" style={{ fontSize: "12px" }}></i> Настройки</Button>
																		)}
																		footer={({
																			close }) => [{
																				name: (<span>Закрыть</span>),
																				callback: () => {
																					if (close) {
																						close();
																					}
																				},
																				options: {
																					type: "primary"
																				}
																			}]}
																	/>
																</div>
																<div style={{ flex: "0 0 60px", display: "flex", justifyContent: "center", alignItems: "center", alignContent: "center" }}>
																	<Dialog
																		auth={auth}
																		content={() => (<CameraForm auth={auth} play={play} allowScan={allowScan} event={event} updateData={updateData} />)}
																		titles={{
																			header: (<div style={{ display: "flex", justifyContent: "center", padding: "10px 15px 0px 15px", fontSize: "16px" }}>
																				Сканер QR-кода
																			</div>)
																		}}
																		trigger={(click) => (<div className='bg bg-grey border-red pointer' style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", alignContent: "center" }}
																			onClick={() => {
																				setAllowScan(true)
																				click()
																			}}
																		><Icofont icon="qr-code" style={{ fontSize: "50px" }} /></div>)}
																		stack={
																			[() => { setAllowScan(false) }]
																		}
																		footer={({
																			close }) => [{
																				name: (<span>Закрыть</span>),
																				callback: () => {
																					if (close) {
																						close();
																					}
																				},
																				options: {
																					type: "primary"
																				}
																			}]}
																	/>
																	{/* <Action
																	auth={auth}

																	form={CameraForm}
																	allowScan={allowScan}
																	action={(values, unlock, close) => {
																		// handleTicket(item);

																		// let r = encodeURIComponent(values?.qr);
																		// play();

																		// console.log("cameraForm action", values, r);
																		// close();
																	}}
																	noAntForm={true}
																	readonly={true}
																	event={event}
																	updateData={updateData}
																	mode="func"
																	titles={{
																		header: (<div style={{ display: "flex", justifyContent: "center", padding: "10px 15px 0px 15px", fontSize: "16px" }}>
																			Сканер QR-кода
																		</div>)
																	}}
																	trigger={(click) => (<div className='bg bg-grey border-red pointer' style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", alignContent: "center" }}
																		onClick={() => {
																			setAllowScan(true)
																			click()
																		}}
																	><Icofont icon="qr-code" style={{ fontSize: "50px" }} /></div>)}
																/> */}

																</div>
															</div>
														</div>
														<div style={{ padding: "5px", height: "100%", minHeight: "0" }}>
															<div style={{ display: "flex", justifyContent: "space-between", paddingBottom: "15px" }}>
																<div className='bg bg-blue border-blue' style={{ flex: "auto" }}>
																	<Input onChange={(v) => setFilter(v)} clearable className={classes.searchInput} placeholder={"Поиск по ФИО"}>
																	</Input>
																</div>
															</div>
															<div className='tickets' ref={headerRef} style={{ height: "100%", overflow: "scroll" }}>
																<div className='bg bg-grey' style={{ marginBottom: "5px", display: "flex", justifyContent: "right" }}>
																	<div style={{ color: "#1890ff", padding: "0 5px" }} onClick={() => setActive(!active)}>
																		<a className={classes.fieldValue} style={{ color: "#1890ff" }} href="#">
																			{(active) ? "Активные" : "Все"}
																		</a>
																		<Icofont icon="hand-up" />
																	</div>
																</div>
																{JSXMap(filteredTickets(), (item, idx) => {
																	return (<div key={item.ID} style={{ padding: "3px 0", borderBottom: "1px solid rgb(225, 225, 225, 0.5)", display: (!item.used || !active) ? "block" : "none" }}>
																		<Action
																			auth={auth}
																			titles={{
																				header: (<div style={{ display: "flex", justifyContent: "center", padding: "10px 15px 0px 15px", fontSize: "16px" }}>
																					Билет
																				</div>)
																			}}

																			action={(values, unlock, close) => {
																				// handleTicket(item);
																				// console.log("Action on dancer", values);
																			}}
																			form={TicketForm}
																			noAntForm={true}
																			readonly={true}
																			event={event}
																			object={item}
																			updateData={updateData}
																			mode={"func"}
																			trigger={(click) => (
																				<div onClick={click}>
																					<div style={{
																						padding: "10px 0",
																						display: "flex",
																						justifyContent: "space-between",
																						flexDirection: "row",
																						flexWrap: "nowrap",
																						alignItems: "stretch",
																						width: "100%",
																						fontSize: "14px",
																						minHeight: "40px",
																						alignItems: "center",
																						background: (item.used === true) ? "repeating-linear-gradient(115deg, transparent, transparent 3px, rgb(225, 225, 225, 0.5) 3px, rgb(225, 225, 225,0.5) 6px)" : "",
																						// textDecoration: (item.used === true) ? "line-through" : "",
																						textDecorationColor: (item.used === true) ? "rgb(0,0,0,0.5)" : ""
																					}}>
																						{(!item?.Polzovatel) && <div>{item.Name}</div>}
																						{(item?.Polzovatel?.genderID === 2) && <div><Icofont icon="businesswoman" style={{ color: "red", fontSize: "16px" }} /> {item.Name}</div>}
																						{(item?.Polzovatel?.genderID === 1) && <div><Icofont icon="businessman" style={{ color: "blue", fontSize: "16px" }} /> {item.Name}</div>}
																					</div>
																				</div>
																			)}
																		/>
																	</div>)
																})}
																{/* <Collection
																data={filteredTickets()}
																selection="checkbox"
																auth={auth}
																noheader={true}
																noPrint={true}
																noPagination={true}
																size="small"
																mode="list"
																listRenderItem={(item, idx) => {
																	// console.log(item);
																	
																}
																}
																collectionActions={() => []}
																modelActions={() => []}
															/> */}
															</div>
														</div>

													</div>
												</div>}
											</div>
										</div>
									</div>
									<div className={"footer"}>
									</div>
								</div>
							</LangSwitchContext.Provider>
						</LanguageContext.Provider>
					</UserConfigContext.Provider>
				</UserContext.Provider>
			</MetaContext.Provider>
		</TranslateContext.Provider >
	);
};

export default Checkticket;